import styled, { css } from 'styled-components';
import { TextField, Text, TextFieldSize } from '@bechtel/gds';

export const TextFieldStyled = styled(TextField).attrs({ size: TextFieldSize.LARGE })`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
    font-family: ${theme.fontFamilies['graphik']};
  `}
`;

export const FieldError = styled(Text)`
  ${({ theme }) => css`
    color: ${theme.colors.bechtel.red};
  `}
`;
